export const saveBrandDetailsAction = payload => {
    return {
        type: 'SAVE_BRAND_DETAILS',
        payload
    }
}